import { z } from 'zod'
import {
  requiredString,
  optionalString,
  currencyPence,
  requiredSelect,
  optionalBoolean,
  optionalFile,
  createResourceSchema
} from './common'

export const menuItemSchema = createResourceSchema({
  name: requiredString('Name'),
  description: optionalString,
  price_pence: currencyPence('Price'),
  category: requiredSelect('Category'),
  sittings: z.array(z.string()).min(1, 'At least one sitting is required'),
  visible: optionalBoolean,
  image: optionalFile
})
